export default __webpack_public_path__ + "static/media/useraccess.68d4f9fe.svg";